import React, { Dispatch, SetStateAction } from 'react';

interface SupportType {
    show: boolean;
    title: string;
    link: string;
}

interface ShowTicketDetailType {
    show: boolean;
    ticketID: any;
}

interface ShowCustomerDetailType {
    show: boolean;
    account_client_id: number;
    info?: any;
}

interface AppContextType {
    support: SupportType, 
    setSupport: Dispatch<SetStateAction<SupportType>>, 

    showTicketDetail: ShowTicketDetailType, 
    setShowTicketDetail: Dispatch<SetStateAction<ShowTicketDetailType>>,
    
    showCustomerDetail: ShowCustomerDetailType, 
    setShowCustomerDetail: Dispatch<SetStateAction<ShowCustomerDetailType>>,
}

export const AppContext = React.createContext<AppContextType>(null);